export default __webpack_public_path__ + "/dist/images/shortlist-icon.99e9a0d12927bc4e0047009749674040.svg";